<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
                <el-col :span="6" :xs="24" :sm="12" :md="6">
                    <el-form-item label="日期服务" prop="datelist">
                    <el-date-picker v-model="searchform.datelist" style="width: 100%" type="daterange"
                      value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" />
                  </el-form-item>
                </el-col>
                <el-col :span="6" :xs="24" :sm="12" :md="6">
                    <el-form-item label="发货仓库编码" prop="outWarehouseCode" label-width="120px">
                        <el-select v-model.trim="searchform.outWarehouseCode" placeholder="请输入仓库名称"
                            style="width:100%" filterable>
                            <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                :label="item.warehouseName" :value="item.warehouseCode" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6" :xs="24" :sm="12" :md="6">
                  <el-form-item label="收货仓库编码" prop="inWarehouseCode"  label-width="120px">
                      <el-select v-model.trim="searchform.inWarehouseCode" placeholder="请输入仓库名称"
                          style="width:80%" filterable>
                          <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                              :label="item.warehouseName" :value="item.warehouseCode" />
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" :xs="24" :sm="12" :md="6">
                  <el-form-item label="状态" prop="status">
                      <el-select style="width: 100%;" v-model="searchform.status" placeholder="请选择状态">
                          <el-option label="待出库" :value="0"></el-option>
                          <el-option label="出库中" :value="1"></el-option>
                          <el-option label="部分出库" :value="2"></el-option>
                          <el-option label="已完成" :value="3"></el-option>
                          <el-option label="已取消" :value="4"></el-option>
                          <el-option label="PDA已完成" :value="5"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
          <el-row>
            <el-col :span="6" :xs="24" :sm="12" :md="6" >
              <el-form-item label="承运商" prop="workgroup_name">
                <el-input v-model="searchform.workgroup_name" style="width:100%" clearable placeholder="请输入承运商" />
              </el-form-item>
            </el-col>

            <el-col :span="8" :offset="1" :xs="24" :sm="12" :md="8">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['barter_select']">搜索</el-button>
              <!-- <el-button v-permission="['barter_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>当日出库订单状态表</h4>
          <el-divider></el-divider>
            <el-table id="parent" v-loading="listLoading" :stripe="true" element-loading-text="拼命加载中" :data="tableData"
            style="width: 100% " :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" border
            :default-sort="{ prop: 'produce_time', order: 'descending' }" max-height="500">
            <!-- sortable -->
            <el-table-column v-for="item in tablecolumn" :key="item.key" :prop="item.key" :label="item.label"
              :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize" :page-size="3"
            :current-page.sync="currentPage" :page-sizes="[3,5,10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

import {
  selectoutbillorder
} from "@/api/physical";
import { pagewarehouse } from "@/api/query";
export default {
  name: "OutOrderList",

  data() {
    return {
      //基础数据
      listLoading: false,
      searchform:{
        pageIndex: 1,
        pageSize: 3,
        datelist: [],
        workgroup_name:null,
        inWarehouseCode:null,
        outWarehouseCode:null,
        status:null
      },
      pagewarehouse: [],
      tableData: [],
      // 分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      tablerow: [],
      tablecolumn: [
        {
          label: "运单号",
          key: "freight_bill_code",
          width: "200",
        },
        {
          label: "出库单号",
          key: "out_bill_code",
          width: "200",
        },
        {
          label: "出库时间",
          key: "out_bill_time",
          width: "200",
        },
        {
          label: "发货仓库编码",
          key: "from_warehouse_code",
          width: "200",
        },
        {
          label: "发货仓库",
          key: "from_warehouse",
          width: "200",
        },
        {
          label: "客户编码",
          key: "dealer_code",
          width: "200",
        },
        {
          label: "客户名称",
          key: "dealer_name",
          width: "200",
        },
        {
          label: "客户地址",
          key: "address",
          width: "200",
        },
        {
          label: "产品编码",
          key: "product_code",
          width: "100",
        },
        {
          label: "产品名称",
          key: "product_name",
          width: "150",
        },
        {
          label: "单位",
          key: "unit_name",
          width: "100",
        },
        {
          label: "计划出库数量",
          key: "plan_quantity",
          width: "100",
        },
        {
          label: "出库人工确认数量",
          key: "confirm_quantity",
          width: "150",
        },
        {
          label: "扫码数量",
          key: "qty2",
          width: "100",
        },
        {
          label: "发货状态",
          key: "status",
          width: "100",
        },
      ],
      codearr:[],
            // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "工单列表",
      autoWidth: true,
      bookType: "xlsx",
    };
  },
  mounted() {

    //请求部门列表数据并且便利到表格
    this.Tabledata({pageIndex:this.searchform.pageIndex,pageSize:this.searchform.pageSize});
    this.getList();
  },
  methods: {
    async getList() {
        const params = {
            pageIndex: 1,
            pageSize: 999,
        }
        const { data } = await pagewarehouse(params)
        this.pagewarehouse = data.list
    },
        // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].out_bill_time = this.$parseTime(obj[i].out_bill_time); // 出库时间

        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          case 3:
            obj[i].status = "已下载";
            break;
          case 4:
            obj[i].status = "扫码中";
            break;
          case 5:
            obj[i].status = "已取消";
            break;
          case 6:
            obj[i].status = "已确认数量";
            break;
          default:
            break;
        }
      }
    },
    Tabledata(obj) {
      // 列表获取
      this.listLoading = true;
          selectoutbillorder(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },


          // 重置按钮
    resetForm(formName) {

      this.codearr = []
      this.$refs[formName].resetFields();
    },
      // 搜索事件
    search() {
      this.Tabledata({
        workgroup_name: this.searchform.workgroup_name,
        inWarehouseCode: this.searchform.inWarehouseCode,
        outWarehouseCode: this.searchform.outWarehouseCode,
        status: this.searchform.status,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageSize: this.searchform.pageSize,
      });
    },

       // 分页跳转事件
    currentchange(page_index) {
      this.searchform.pageIndex = page_index;
      this.Tabledata({
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize,
      });
    },
    // 分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.pageSize = page_size;
      this.search();
    },
    // 导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        workgroup_name: this.searchform.workgroup_name,
        inWarehouseCode: this.searchform.inWarehouseCode,
        outWarehouseCode: this.searchform.outWarehouseCode,
        page_index: this.searchform.page_index,
        pageSize: this.total_count,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        status: this.searchform.status,
      };
      selectoutbillorder(obj).then((response) => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "工厂",
            "车间",
            "产线",
            "班组",
            "ERP行号",
            "订单",
            "产品",
            "计划生产数量",
            "人工确认数量",
            "批次号",
            "有效期",
            "1级采集数量",
            "1级生产数量",
            "1级采集率",
            "2级采集数量",
            "2级生产数量",
            "2级采集率",
            "3级采集数量",
            "3级生产数量",
            "3级采集率",
            "4级采集数量",
            "4级生产数量",
            "4级采集率",
            "5级采集数量",
            "5级生产数量",
            "5级采集率",
            "生产开始时间",
            "工单完成时间",
            "计划开始时间",
            "计划完成时间",
            "计划生产日期",
            "生产状态",
            "质检状态",
          ];
          const filterVal = [
            "factory_code",
            "workshop_code",
            "workline_code",
            "workgroup_code",
            "line_item_number",
            "orderno",
            "product_name",
            "product_quantity",
            'reality_instorage_count',
            "batchno",
            "period_date",
            "package_level1_count",
            "package_level1_produce",
            "harvest_rate1",
            "package_level2_count",
            "package_level2_produce",
            "harvest_rate2",
            "package_level3_count",
            "package_level3_produce",
            "harvest_rate3",
            "package_level4_count",
            "package_level4_produce",
            "harvest_rate4",
            "package_level5_count",
            "package_level5_produce",
            "harvest_rate5",
            "produce_time",
            "complete_time",
            "plan_datetime1",
            "plan_datetime2",
            "plan_date",
            "statusname",
            "quality_statusmean",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          // 🛡️ 防御：确保每行数据长度和表头一致
            if (data.length > 0 && data[0].length !== tHeader.length) {
              this.$message.error('数据结构异常：列数不匹配，请刷新重试',data[0].length,tHeader.length );
             console.log('数据结构异常：列数不匹配，请刷新重试',data[0],tHeader );
              this.downloadLoading = false;
              return;
            }
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>
